"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingList = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const console_1 = require("@rws-framework/console");
const PopupService_1 = __importStar(require("../../../services/PopupService"));
const component_1 = require("../../../components/site-menu/component");
const backendImport_1 = require("@front/backendImport");
const acl_helpers_1 = require("@back/app/acl_module/acl.helpers");
const component_2 = require("@front/layouts/default-layout/component");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
    <div class="dashboard-wrapper">
        <div class="firms-list row">
            <div class="form   col-12 pb-lg-5">
               

                <div class="mb-2">
					 
						<h1>${'onboarding.list.title'.t()}</h1>
					 
						<p>${'onboarding.list.description'.t()}</p> 
					 
                </div>
  
				
                <div class="mb-5">
                    <div class="row">
                        <div class="col-12">
                            <div class="card p-4">
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <h5><i class="fas fa-list mr-2"></i>${'onboarding.list.records'.t()}</h5>
                                    <button @click="${x => x.navigateToAdd()}" class="btn btn-primary" ?hidden="${x => !x.canAdd}">
                                        <i class="fas fa-plus mr-2"></i>${'onboarding.create'.t()}
                                    </button>
                                </div>
                                
                                
                                <div class="row mb-3">
                                    <div class="col-md-6">
                                        <input type="text" class="form-control" placeholder="${'onboarding.search.placeholder'.t()}" id="searchInput" :value="${x => x.searchQuery}">
                                    </div>
                                    <div class="col-md-3">
                                        <select class="form-control" id="statusFilter">
                                            <option value="">${'onboarding.status.all'.t()}</option>
                                            <option value="in_progress">${'onboarding.status.in_progress'.t()}</option>
                                            <option value="completed">${'onboarding.status.completed'.t()}</option>
                                            <option value="abandoned">${'onboarding.status.abandoned'.t()}</option>
                                        </select>
                                    </div>
                                    <div class="col-md-3">
                                        <button class="btn btn-outline-secondary" id="filterBtn">
                                            <i class="fas fa-filter mr-2"></i>${'onboarding.filter'.t()}
                                        </button>
                                    </div>
                                </div>
                                
                                
                                <div class="table-responsive">
                                    <table class="table table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <th>${'onboarding.status'.t()}</th>
                                                <th>${'onboarding.profession'.t()}</th>
                                                <th>${'onboarding.avatar.name'.t()}</th>
                                                <th>${'onboarding.currentStep'.t()}</th>
                                                <th>${'onboarding.progress'.t()}</th>
                                                <th>${'onboarding.knowledge.items'.t()}</th>
                                                <th>${'onboarding.createdBy'.t()}</th>
                                                <th>${'onboarding.createdAt'.t()}</th>
                                                <th>${'actions'.t()}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            ${(0, fast_element_1.repeat)(x => x.filteredOnboardingRecords, (0, fast_element_1.html) `
                                                <tr>
                                                    <td>
                                                        ${(0, fast_element_1.when)(record => record.status === 'completed', (0, fast_element_1.html) `
                                                            <span class="badge badge-success">${'onboarding.status.completed'.t()}</span>
                                                        `)}
                                                        ${(0, fast_element_1.when)(record => record.status === 'in_progress', (0, fast_element_1.html) `
                                                            <span class="badge badge-warning">${'onboarding.status.in_progress'.t()}</span>
                                                        `)}
                                                        ${(0, fast_element_1.when)(record => record.status === 'abandoned', (0, fast_element_1.html) `
                                                            <span class="badge badge-danger">${'onboarding.status.abandoned'.t()}</span>
                                                        `)}
                                                        ${(0, fast_element_1.when)(record => !record.status || (record.status !== 'completed' && record.status !== 'in_progress' && record.status !== 'abandoned'), (0, fast_element_1.html) `
                                                            <span class="badge badge-secondary">${record => record.status || 'onboarding.status.unknown'.t()}</span>
                                                        `)}
                                                    </td>
                                                    <td>${record => { var _a; return ((_a = record.profession) === null || _a === void 0 ? void 0 : _a.name) || '-'; }}</td>
                                                    <td>${(0, fast_element_1.when)(x => x.avatar, (0, fast_element_1.html) `<a class="avatar-link" @click="${(x, c) => c.parent.goAvatar(x.avatar.id, c.event)}" href="/avatar/form/${record => record.avatar.id}">${record => { var _a; return ((_a = record.avatar_config) === null || _a === void 0 ? void 0 : _a.name) || '-'; }}</a></td>`, (0, fast_element_1.html) `-`)}
                                                    <td>${record => record.status === 'completed' ? '-' : (record.current_step) || '-'}</td>
                                                    <td>
                                                        <div class="progress" style="height: 20px;">
                                                            <div class="progress-bar" 
                                                                 :style="${(record, c) => 'width: ' + c.parent.getProgressPercentage(record) + '%'}" 
                                                                 role="progressbar">
                                                                ${(record, c) => c.parent.getProgressPercentage(record)}%
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <span class="badge badge-info">${record => { var _a; return ((_a = record.knowledge_ids) === null || _a === void 0 ? void 0 : _a.length) || 0; }}</span>
                                                    </td>
                                                    <td>
                                                        <span class="badge badge-success" ?hidden="${record => !record.user}">
                                                            <i class="fas fa-check mr-1"></i>${record => { var _a; return (_a = record.user) === null || _a === void 0 ? void 0 : _a.name; }}
                                                        </span>
                                                        <span class="text-muted" ?hidden="${record => record.user}">-</span>
                                                    </td>
                                                    <td>
                                                      
                                                      <td>
                                                          ${(record, c) => c.parent.formatDate(record.created_at, 'yyyy-MM-dd')}<br/>
                                                          <small class="text-muted"> ${(record, c) => c.parent.formatDate(record.created_at, 'HH:mm:ss')}</small>
                                                      </td>
                                                    </td>
                                                    <td>
                                                        <div class="btn-group btn-group-sm">
                                                            <rws-tooltip side="left" text="${'onboarding.tooltip.view'.t()}">
                                                                <button class="btn btn-outline-primary btn-sm" 
                                                                        @click="${(record, c) => c.parent.viewRecord(record.id)}">
                                                                    <i class="simple-icon-eye"></i>
                                                                </button>
                                                            </rws-tooltip>
                                                            <rws-tooltip side="left" text="${'onboarding.tooltip.edit'.t()}">
                                                                <button class="btn btn-outline-warning btn-sm" 
                                                                        @click="${(record, c) => c.parent.editRecord(record.id)}">
                                                                    <i class="simple-icon-pencil"></i>
                                                                </button>
                                                            </rws-tooltip>
                                                            <rws-tooltip side="left"  text="${'onboarding.tooltip.delete'.t()}">
                                                                <button  class="btn btn-outline-danger btn-sm" 
                                                                        @click="${(record, c) => c.parent.deleteRecord(record.id)}">
                                                                    <i class="simple-icon-trash"></i>
                                                                </button>
                                                            </rws-tooltip>
                                                        </div>
                                                    </td>
                                                </tr>
                                            `)}
                                            <tr ?hidden="${x => x.filteredOnboardingRecords.length > 0}">
                                                <td colspan="9" class="text-center text-muted py-4">
                                                    ${'onboarding.list.empty'.t()}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                
                                
                                <nav aria-label="${'onboarding.pagination.navigation'.t()}" class="mt-3">
                                    <ul class="pagination justify-content-center">
                                        
                                        <li class="page-item" :class="${x => x.currentPage <= 1 ? 'disabled' : ''}">
                                            <button class="page-link" 
                                                    @click="${x => x.previousPage()}" 
                                                    ?disabled="${x => x.currentPage <= 1}">
                                                ${'pagination.previous'.t()}
                                            </button>
                                        </li>
                                        
                                        
                                        ${(0, fast_element_1.repeat)(x => x.pageNumbers, (0, fast_element_1.html) `
                                            <li class="page-item" :class="${(page, c) => c.parent.currentPage === page ? 'active' : ''}">
                                                <button class="page-link" 
                                                        @click="${(page, c) => c.parent.goToPage(page)}">
                                                    ${page => page}
                                                </button>
                                            </li>
                                        `)}
                                        
                                        
                                        <li class="page-item" :class="${x => x.currentPage >= x.totalPages ? 'disabled' : ''}">
                                            <button class="page-link" 
                                                    @click="${x => x.nextPage()}" 
                                                    ?disabled="${x => x.currentPage >= x.totalPages}">
                                                ${'pagination.next'.t()}
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                
                
                <div class="row">
                    <div class="col-md-3">
                        <div class="card bg-primary text-white">
                            <div class="card-body">
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <h4>${x => x.stats.total || 0}</h4>
                                        <p class="mb-0">${'onboarding.stats.total'.t()}</p>
                                    </div>
                                    <div class="align-self-center">
                                        <i class="fas fa-list fa-2x"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card bg-warning text-white">
                            <div class="card-body">
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <h4>${x => x.stats.inProgress || 0}</h4>
                                        <p class="mb-0">${'onboarding.stats.in_progress'.t()}</p>
                                    </div>
                                    <div class="align-self-center">
                                        <i class="fas fa-clock fa-2x"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card bg-success text-white">
                            <div class="card-body">
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <h4>${x => x.stats.completed || 0}</h4>
                                        <p class="mb-0">${'onboarding.stats.completed'.t()}</p>
                                    </div>
                                    <div class="align-self-center">
                                        <i class="fas fa-check-circle fa-2x"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card bg-info text-white">
                            <div class="card-body">
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <h4>${x => x.stats.avatarsCreated || 0}</h4>
                                        <p class="mb-0">${'onboarding.stats.avatars_created'.t()}</p>
                                    </div>
                                    <div class="align-self-center">
                                        <i class="fas fa-user-plus fa-2x"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
				
                 
            </div>
        </div>

      
    </div>
</div>
`;
require("./styles/layout.scss");
const styles = T.css `#etapTabs button {
  width: 100%;
}

.avatars-select {
  box-shadow: none;
  background: transparent;
  padding: 0;
  margin: 0;
  height: auto;
}
.avatars-select .name {
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.75rem;
  padding: 0.5rem 1rem;
  background: #fff;
  box-shadow: 0 1px 15px rgba(0, 0, 0, 0.04), 0 1px 6px rgba(0, 0, 0, 0.04);
}
.avatars-select span .me-3 {
  margin-right: 0.5rem;
}

.avatar-link {
  text-decoration: underline;
}`;
const shadowOptions = { "mode": "open" };
let OnboardingList = class OnboardingList extends client_1.RWSViewComponent {
    constructor(popupService) {
        super();
        this.popupService = popupService;
        this.onboardingRecords = [];
        this.filteredOnboardingRecords = [];
        this.currentPage = 1;
        this.totalPages = 1;
        this.pageNumbers = [];
        this.searchQuery = '';
        this.loading = false;
        this.stats = {
            total: 0,
            inProgress: 0,
            completed: 0,
            avatarsCreated: 0
        };
        this.canAdd = false;
        this.canEditGlobal = false;
        this.canDeleteGlobal = false;
    }
    connectedCallback() {
        var _a;
        super.connectedCallback();
        // Set up global permissions
        const isSuperAdmin = ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
        this.canAdd = isSuperAdmin || (0, acl_helpers_1.checkACL)(`${backendImport_1.ACL.aclResources.onboarding}.${backendImport_1.ACL.aclActions.write}`, component_2.DefaultLayout.USER.acl);
        this.canEditGlobal = isSuperAdmin || (0, acl_helpers_1.checkACL)(`${backendImport_1.ACL.aclResources.onboarding}.${backendImport_1.ACL.aclActions.write}`, component_2.DefaultLayout.USER.acl);
        this.canDeleteGlobal = isSuperAdmin || (0, acl_helpers_1.checkACL)(`${backendImport_1.ACL.aclResources.onboarding}.${backendImport_1.ACL.aclActions.delete}`, component_2.DefaultLayout.USER.acl);
        console.log('XXXX');
        // Make instance available globally for onclick handlers
        window.onboardingList = this;
        this.setupEventListeners();
        this.loadData();
    }
    setupEventListeners() {
        // Listen for search events
        this.addEventListener('search-changed', (event) => {
            this.searchQuery = event.detail.query;
        });
        this.addEventListener('search-submit', (event) => {
            this.searchQuery = event.detail.query;
            this.currentPage = 1; // Reset to first page when searching
            this.loadData();
        });
        // Search input handler
        const searchInput = this.querySelector('#searchInput');
        if (searchInput) {
            searchInput.addEventListener('input', (e) => {
                this.searchQuery = e.target.value;
            });
            searchInput.addEventListener('keypress', (e) => {
                if (e.key === 'Enter') {
                    this.currentPage = 1;
                    this.loadData();
                }
            });
        }
        // Filter button handler
        const filterBtn = this.querySelector('#filterBtn');
        if (filterBtn) {
            filterBtn.addEventListener('click', () => {
                this.currentPage = 1;
                this.loadData();
            });
        }
    }
    async loadData() {
        this.loading = true;
        try {
            let routeOptions = {};
            if (this.searchQuery) {
                routeOptions.routeParams = { q: this.searchQuery };
            }
            if (this.currentPage !== null) {
                routeOptions.queryParams = {
                    p: this.currentPage.toString(),
                    per_page: '20'
                };
            }
            const response = await this.apiService.back.get('onboarding.list', routeOptions);
            if (response.success) {
                this.onboardingRecords = response.data || [];
                this.filteredOnboardingRecords = this.onboardingRecords; // Set filtered records
                this.totalPages = Math.max(1, Math.ceil(response.count / 20));
                this.updatePageNumbers();
                this.calculateStats();
            }
            else {
                this.notifyService.notify(response.error || 'Failed to load onboarding data', 'error');
            }
        }
        catch (error) {
            console.error('Error loading onboarding data:', error);
            this.notifyService.notify('Failed to load onboarding data', 'error');
        }
        finally {
            this.loading = false;
        }
    }
    calculateStats() {
        this.stats = {
            total: this.onboardingRecords.length,
            inProgress: this.onboardingRecords.filter(r => r.status === 'in_progress').length,
            completed: this.onboardingRecords.filter(r => r.status === 'completed').length,
            avatarsCreated: this.onboardingRecords.filter(r => r.avatar).length
        };
    }
    updatePageNumbers() {
        this.pageNumbers = [];
        for (let page = 1; page <= this.totalPages; page++) {
            this.pageNumbers.push(page);
        }
    }
    getStatusBadge(status) {
        const statusClasses = {
            'in_progress': 'badge-warning',
            'completed': 'badge-success',
            'abandoned': 'badge-danger'
        };
        const statusTexts = {
            'in_progress': 'In Progress',
            'completed': 'Completed',
            'abandoned': 'Abandoned'
        };
        const badgeClass = statusClasses[status] || 'badge-secondary';
        const statusText = statusTexts[status] || status;
        return `<span class="badge ${badgeClass}">${statusText}</span>`;
    }
    getProgressPercentage(record) {
        // TODO: Fix this to work with proper profession-step relationship
        // The steps are loaded separately via onboarding.profession.steps endpoint
        // if (!record.profession || !record.profession.steps.length || record.current_step === undefined || record.current_step === null) {
        //     return 0;
        // }
        // const totalSteps = record.profession.steps.length + 2;
        // const completedSteps = (record.completed_steps || []).length + 1;
        // return Math.round((completedSteps / totalSteps) * 100);
        // Simplified version for now
        if (record.status === 'completed')
            return 100;
        if (record.status === 'in_progress')
            return 50;
        return 0;
    }
    formatDate(date, format) {
        return console_1.DateUtils.create(date).format(format);
    }
    getPageNumbers() {
        const pages = [];
        for (let i = 1; i <= this.totalPages; i++) {
            pages.push(i);
        }
        return pages;
    }
    previousPage() {
        if (this.currentPage > 1) {
            this.currentPage--;
            this.loadData();
        }
    }
    nextPage() {
        if (this.currentPage < this.totalPages) {
            this.currentPage++;
            this.loadData();
        }
    }
    goToPage(page) {
        this.currentPage = page;
        this.loadData();
    }
    viewRecord(id) {
        component_1.SiteMenu.goto.bind(this)(`/onboarding/${id}`);
    }
    editRecord(id) {
        component_1.SiteMenu.goto.bind(this)(`/onboarding/wizard/${id}`);
    }
    navigateToAdd() {
        component_1.SiteMenu.goto.bind(this)('/onboarding/pick');
    }
    async deleteRecord(id) {
        if (!await this.popupService.confirm('Are you sure you want to delete this onboarding record?')) {
            return false;
        }
        try {
            this.loading = true;
            const response = await this.apiService.back.delete('onboarding.delete', { routeParams: { id } });
            if (response.success) {
                // Remove the item from the local list
                this.onboardingRecords = this.onboardingRecords.filter(r => String(r.id) !== id);
                this.calculateStats();
                this.notifyService.notify('Onboarding record deleted successfully', 'info');
                this.loadData();
                return true;
            }
            else {
                this.notifyService.notify(response.error || 'Failed to delete onboarding record', 'error');
                return false;
            }
        }
        catch (error) {
            console.error('Error deleting onboarding record:', error);
            this.notifyService.notify('Failed to delete onboarding record', 'error');
            return false;
        }
        finally {
            this.loading = false;
        }
    }
    getStatusClass(status) {
        switch (status) {
            case 'completed':
                return 'success';
            case 'in_progress':
                return 'primary';
            case 'failed':
                return 'danger';
            default:
                return 'secondary';
        }
    }
    goAvatar(id, event) {
        event.preventDefault();
        component_1.SiteMenu.goto.bind(this)(`/avatar/form/${id}`);
    }
    canEdit(onboarding) {
        var _a;
        const isSuperAdmin = ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
        if (isSuperAdmin)
            return true;
        // Always allow creators to edit their onboarding records
        if (this.isUserOwnerOrCreator(onboarding))
            return true;
        // Otherwise check global permission
        return this.canEditGlobal;
    }
    canDelete(onboarding) {
        var _a;
        const isSuperAdmin = ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
        if (isSuperAdmin)
            return true;
        // Always allow creators to delete their onboarding records
        if (this.isUserOwnerOrCreator(onboarding))
            return true;
        // Otherwise check global permission
        return this.canDeleteGlobal;
    }
    isUserOwnerOrCreator(onboarding) {
        var _a;
        const currentUserId = component_2.DefaultLayout.USER.id;
        const onboardingOwnerId = onboarding.owner ? onboarding.owner : null;
        const onboardingCreatorId = ((_a = onboarding.user) === null || _a === void 0 ? void 0 : _a.id) ? onboarding.user.id : null; // user is creator
        return onboardingOwnerId === currentUserId || onboardingCreatorId === currentUserId;
    }
};
exports.OnboardingList = OnboardingList;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], OnboardingList.prototype, "onboardingRecords", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], OnboardingList.prototype, "filteredOnboardingRecords", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], OnboardingList.prototype, "currentPage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], OnboardingList.prototype, "totalPages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], OnboardingList.prototype, "pageNumbers", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], OnboardingList.prototype, "searchQuery", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], OnboardingList.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], OnboardingList.prototype, "stats", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], OnboardingList.prototype, "canAdd", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], OnboardingList.prototype, "canEditGlobal", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], OnboardingList.prototype, "canDeleteGlobal", void 0);
exports.OnboardingList = OnboardingList = __decorate([
    (0, client_1.RWSView)('onboarding-list', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object])
], OnboardingList);
OnboardingList.defineComponent();
